import {createFromIconfontCN} from '@ant-design/icons/lib';

const MyIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2771635_9iofiwy4kcg.js', // 在 iconfont.cn 上生成
});

export default MyIcon;
